// reference: https://github.com/remix-run/react-router/discussions/10160

import { lazy } from 'react'
import { Route } from 'react-router-dom'

import routes from 'utils/routes'
import { SENTRY_TAG } from '@hotmart/hub-components'

import { PrivateRoute } from 'components/index'

const RegularizePaymentPage = lazy(() => import('payments_subscriptions/RegularizePaymentPage'))
const RegularizePaymentPageCollections = lazy(() => import('payments_subscriptions/RegularizePaymentPageCollections'))

const RegularizePaymentByBilletPage = lazy(() => import('payments_subscriptions/RegularizePaymentByBilletPage'))
const RegularizePaymentByCreditCardPage = lazy(() => import('payments_subscriptions/RegularizePaymentByCreditCardPage'))
const RegularizePaymentByPixPage = lazy(() => import('payments_subscriptions/RegularizePaymentByPixPage'))
const CreditCardPaymentErrorPage = lazy(() => import('payments_subscriptions/CreditCardPaymentErrorPage'))
const CreditCardPaymentSuccessPage = lazy(() => import('payments_subscriptions/CreditCardPaymentSuccessPage'))
const ErrorRegularizePaymentPage = lazy(() => import('payments_subscriptions/ErrorRegularizePaymentPage'))
const PaymentApprovedPage = lazy(() => import('payments_subscriptions/PaymentApprovedPage'))

export function useRegularizePaymentPageCollectionsRouter() {
  const { regularizePayment } = routes.paymentsSubscription

  return (
    <Route
      path={regularizePayment}
      element={<PrivateRoute sentryTag={SENTRY_TAG.SUBSCRIPTION} element={RegularizePaymentPageCollections} />}
    />
  )
}

export function useRegularizePaymentPageRouter() {
  const { regularizePayment, regularizeByPix, regularizeByBillet, regularizeByCreditCard } = routes.paymentsSubscription

  return (
    <>
      <Route element={<PrivateRoute sentryTag={SENTRY_TAG.SUBSCRIPTION} element={RegularizePaymentPage} />}>
        <Route
          path={`${regularizePayment}/${regularizeByBillet}`}
          element={<PrivateRoute sentryTag={SENTRY_TAG.SUBSCRIPTION} element={RegularizePaymentByBilletPage} />}
        />
        <Route
          path={`${regularizePayment}/${regularizeByCreditCard}`}
          element={<PrivateRoute sentryTag={SENTRY_TAG.SUBSCRIPTION} element={RegularizePaymentByCreditCardPage} />}
        />
        <Route
          path={`${regularizePayment}/${regularizeByPix}`}
          element={<PrivateRoute sentryTag={SENTRY_TAG.SUBSCRIPTION} element={RegularizePaymentByPixPage} />}
        />
      </Route>

      <Route
        path={routes.paymentsSubscription.creditCardPaymentError}
        element={<PrivateRoute sentryTag={SENTRY_TAG.SUBSCRIPTION} element={CreditCardPaymentErrorPage} />}
      />
      <Route
        path={routes.paymentsSubscription.creditCardPaymentSuccess}
        element={<PrivateRoute sentryTag={SENTRY_TAG.SUBSCRIPTION} element={CreditCardPaymentSuccessPage} />}
      />
      <Route
        path={routes.paymentsSubscription.errorRegularizePayment}
        element={<PrivateRoute sentryTag={SENTRY_TAG.SUBSCRIPTION} element={ErrorRegularizePaymentPage} />}
      />
      <Route
        path={routes.paymentsSubscription.paymentApprovedPage}
        element={<PrivateRoute sentryTag={SENTRY_TAG.SUBSCRIPTION} element={PaymentApprovedPage} />}
      />
    </>
  )
}
